// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__rDIGu","particlesAnimation":"Hero_particlesAnimation__SUeph","container":"Hero_container__JKECA"};